import { Component, Input } from '@angular/core';
import { IEmailJob } from '../../../../models/emailJob';
import { resolveStateClass } from '../../../sessions/campaigns.service';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Component({
  selector: 'email-jobs',
  templateUrl: './email-jobs.component.html',
})
export class EmailJobsComponent {
  @Input() jobs: IEmailJob[] = [];

  constructor(private translateService: TranslateService) {}

  public resolveStateClass(job: IEmailJob): string {
    return resolveStateClass(job.job_status);
  }

  public formatDate(date: Date): string {
    if (!date) {
      return '-';
    } 
    const lang = this.translateService.store.currentLang || this.translateService.store.defaultLang;
    return lang.toLowerCase().substring(0, 2) === 'fr' ? moment(date).format("DD/MM/YYYY HH:mm") : moment(date).format("MM/DD/YYYY, hh:mm A");
  }
  
}



// WEBPACK FOOTER //
// ./src/app/modules/email/campaigns/email-jobs/email-jobs.component.ts